import c from '../util/const';

let initialState = {
  email: null,
  memberNumber: null,
  code: null,
  token: null,
  vip: null,
  sid: null,
  step: null,
  tfaAuth: null,
  institution: null,
  emailFieldIsVisible: true,
  preventEmailDisabled : false,
  loginWithPayment : false,
  upgradeClassInfo : null,
  emailValidationPerformed : false,
  emailValidationResults : null,
  showEmailValidationWarning : false,
  allowEmailEditFromBoarding : false,
  isEnteringOTPCode : false,
  isDoingCaptchaStep : false,
  captchaRes : null
}

const app = (state = initialState, action) => {
  switch (action.type) {

    case c.actions.auth.setStep:
      return {
        ...state,
        step: action.step
      };

    case c.actions.auth.setAllowEmailEditFromBoarding:
      return {
        ...state,
        allowEmailEditFromBoarding: action.allowEmailEditFromBoarding
      }

    case c.actions.auth.setIsEnteringOTPCode:
      return {
        ...state,
        isEnteringOTPCode: action.isEnteringOTPCode
      }

    case c.actions.auth.setIsDoingCaptchaStep:
      return {
        ...state,
        isDoingCaptchaStep: action.isDoingCaptchaStep
      }

    case c.actions.auth.setCaptchaRes:
      return {
        ...state,
        captchaRes: action.captchaRes
      }

    case c.actions.auth.setEmailValidationResults:
      return {
        ...state,
        emailValidationResults: action.emailValidationResults
      };

    case c.actions.auth.setShowingInvalidEmailWarning:
      return {
        ...state,
        showEmailValidationWarning: action.showEmailValidationWarning
      };

    case c.actions.auth.setEmailValidationPerformed:
      return {
        ...state,
        emailValidationPerformed: action.emailValidationPerformed
      };

    case c.actions.auth.loginWithPayment:
      return {
        ...state,
        loginWithPayment : action.loginWithPayment
      }

    case c.actions.auth.preventEmailDisabled:
      return {
        ...state,
        preventEmailDisabled: action.preventEmailDisabled
      };

    case c.actions.auth.setEmailFieldVisible:
      return {
        ...state,
        emailFieldIsVisible: action.emailFieldIsVisible
      };

    case c.actions.auth.setInstitution:
      return {
        ...state,
        institution: {...action.institution}
      };

    case c.actions.auth.setUpgradePlan:
      return {
        ...state,
        upgradeClassInfo: action.upgradeClassInfo
      };

    case c.actions.auth.setEmail:
      return {
        ...state,
        email: action.email
      };

    case c.actions.auth.setMemberNumber:
      return {
        ...state,
        memberNumber: action.number
      };

    case c.actions.auth.setConfirmationCode:
      return {
        ...state,
        code: action.code
      };

    case c.actions.auth.setTFAAuth:
      return {
        ...state,
        tfaAuth : action.tfaAuth
      }

    case c.actions.auth.setAuth:
      return {
        ...state,
        token: action.token,
        vip: action.vip,
        sid: action.sid
      };

    case c.actions.auth.logout:
      return {
        ...initialState,
        email : state.email,
        step : c.authSteps.password,
      }

    default:
      return state;
  }
}

export default app;
